import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {SearchSpan,AddNewButtonLayout} from '../../common/Global/globalStyles.style';
import FilterDropDown from '../../common/DropdownMenus/FilterDropdown';
import AlertDialog from '../../common/AlertDialog';
import Pagination from '../../common/Global/pagination';
import SelectDepartmentDialog from '../../pages/Tasks/selectDepartment';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import {getLocalStorageVariables,isEmptyVariable,sortTable,
    isEmptyArray,
    handleTokenExpiry,
    getThemeSettingsVariables,
    isJsonString} from '../../common/Global/commonFunctions';
import Sidebar from '../../common/Sidebar';
import Topbar from '../../common/Topbar';
import ClientTabs from './topmenu';

let userDetails = {};
let themeSettings = getThemeSettingsVariables();

const sortDashboardName = "dc.dashboardClientName";
const sortDescription = "dc.dashboardClientDescription";
const sortRootExecuteTemplateId = "dc.rootExecuteTemplateId";
const departmentFilterDropdownDefaultValue = "All";
class clientDashboard extends Component {
    constructor(props) {
        super(props);
        const item = props.location.state;
        this.state = {
            componentDidMountFlag:false,
            apiSearchKey:"",
            clientSearchkey:"",
            currentPageNo: 1,
            showLoader:false,
            resultSize:Constants.RESULT_SIZE,
            totalCount:0,
            datalist:[],
            statusPlaceholder:"Active",
            resultSizePlaceholder:Constants.RESULT_SIZE,
            sort:sortDashboardName,
            sortDir:"asc",

            status:"Active",
            statusArr:[
                {
                    label:"Active",
                    isSelected:true
                },
                {
                    label:"Inactive",
                    isSelected:false
                }
            ],
            resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
            showAlertDialogInfo: false,
			alertDialogMessageInfo: "",
            clientId:this.props.match.params.id,
            departmentList:item?.departmentList ?? [],
            companyName:item?.companyName ?? "",
            selectedFilterDepartmentName:departmentFilterDropdownDefaultValue,
            selectedFilterDepartmentId:""
        }
    }

    componentDidMount(){
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
        let filterDeptArr = [];
        let selectedFilterDepartmentId = "";
        let selectedFilterDepartmentName = "All";
        if (!isEmptyArray(this.state.departmentList) && this.state.departmentList.length === 1) {
        } else {
            let obj = {
                departmentId: "",
                name: departmentFilterDropdownDefaultValue,
                isSelected: true,
            };
            filterDeptArr = [...this.state.departmentList];
            filterDeptArr.splice(0, 0, obj);
        }
        this.setState({
            filterDeptArr:filterDeptArr,
			selectedFilterDepartmentId: selectedFilterDepartmentId,
			selectedFilterDepartmentName: selectedFilterDepartmentName,
        })
        this.getDashboardsList();
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onSearchIconClick = () => {
        this.getDashboardsList();
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.getDashboardsList();
        }
    }

    handleAlertDialogCloseInfo = () => {
		this.setState({
			showAlertDialogInfo: false,
			alertDialogMessageInfo: "",
		},() => {
            this.getDashboardsList();
        });
	};

    statusDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.statusArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.label;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            statusArr:tempArr,
            status:item.label,
            statusPlaceholder:placeholder
        }, () => {
            this.getDashboardsList();
        })
    }

    resultSizeDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.resultSizeArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.label ;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            resultSizeArr:tempArr,
            resultSize:item.label,
            resultSizePlaceholder:placeholder
        },() => {
            this.getDashboardsList();
        })
    }

    deptFilterDropdownClick = (item, selectedIndex) => {
		let placeholder = "";
		let id = "";
		let filterDeptArr = this.state.filterDeptArr;

		for (const [i, value] of filterDeptArr.entries()) {
			if (i === selectedIndex) {
				filterDeptArr[i].isSelected = true;
				placeholder = value.name;
				id = value.departmentId;
			} else {
				filterDeptArr[i].isSelected = false;
			}
		}

		this.setState({
	    	currentPageNo: 1,
	    	selectedFilterDepartmentName: placeholder,
	    	selectedFilterDepartmentId: id
	    }, () => {
            this.getDashboardsList();
        });
	};

    sortTableLocal = (sortColumn) => {
        let sortObj = sortTable(sortColumn,this.state.sort,this.state.sortDir);

        this.setState({
            sort:sortObj.sortTemp,
            sortDir:sortObj.sortDirTemp,
        },()=>{
            this.getDashboardsList();
        })
    }

    addDashboard = () => {
        this.setState({
            showSelectDeptDialog:true,
            dashboardList:this.state.datalist
        })
    }

    handleSelectDeptDialogClose = () => {
        this.setState({
            showSelectDeptDialog:false,
        })
    }

    handleSelectDeptDialogSaveClose = (selectedDepartmentId) => {
        let departmentArr = this.state.departmentList.find(item => item.departmentId == selectedDepartmentId)
        this.props.history.push(Constants.URL_ADD_CLIENT_DASHBOARD,{
            clientId:this.state.clientId,
            companyName:this.state.companyName,
            departmentArr:departmentArr
        })
    }
    
    /*******************API CALLS*******************/
    getDashboardsList = () => {
        this.setState({
            showLoader:true,
        });
        const departmentIds = this.state.departmentList.map(item => item.departmentId);
        fetch(Constants.Dashboards+"/"+this.state.clientId,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                pageNo:this.state.currentPageNo,
                search:this.state.clientSearchkey,
                resultsize:this.state.resultSize,
                status:this.state.status,
                sort:this.state.sort,
                sortDir:this.state.sortDir,
                departmentIdList:this.state.selectedFilterDepartmentId ? JSON.stringify([this.state.selectedFilterDepartmentId]) : JSON.stringify(departmentIds)
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    componentDidMountFlag:true,
                    datalist:data.data.clientDashboardList,
                    totalCount:data.data.totalCount,
                    apiSearchKey:this.state.clientSearchkey
                })
            }else{
                this.setState({
                    datalist:[],
                    totalCount:0,
                    showLoader:false,
                    componentDidMountFlag:true,
                    apiSearchKey:this.state.clientSearchkey,
                })
            }
        });
    }

    onChangePage = (page) => {
        // update state with new page of items
        userDetails  = getLocalStorageVariables();
        const departmentIds = this.state.departmentList.map(item => item.departmentId);
        if(page !== this.state.currentPageNo){
            this.setState({
                showLoader:true,
            });
            
            fetch(Constants.Dashboards+"/"+this.state.clientId,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    pageNo:page,
                    search:this.state.clientSearchkey,
                    resultsize:this.state.resultSize,
                    status:this.state.status,
                    sort:this.state.sort,
                    sortDir:this.state.sortDir,
                    departmentIdList:this.state.selectedFilterDepartmentId ? JSON.stringify([this.state.selectedFilterDepartmentId]) : JSON.stringify(departmentIds)
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        showLoader:false,
                        componentDidMountFlag:true,
                        datalist:data.data.clientDashboardList,
                        totalCount:data.data.totalCount,
                        apiSearchKey:this.state.clientSearchkey,
                        currentPageNo:page,
                    })
                }else{
                    this.setState({
                        datalist:[],
                        showLoader:false,
                        componentDidMountFlag:true,
                        apiSearchKey:this.state.clientSearchkey,
                    })
                }
            });
        }
    }

    render() {
        return(
            <Router>
    			<main className="main-dashboard clientDashboard-tooltip">
                    <section className="dashboard-bg">
                        <Sidebar />
                        <div className="dashboard-right-bg position-relative">
						    <div className="dashboard-wrapper">
                                <Topbar />
                                <ClientTabs
                                    clientId={this.state.clientId}
                                    displayingClients={true}
                                    displayingTemplates={false}
                                    themeSettings = {themeSettings}
                                    companyName={this.state.companyName}
                                    showInfo={false}
                                />
                                {
                                    this.state.showLoader &&
                                    <div class="loader"></div>
                                }
                                {
                                    // Need to check component did mount flag, other wise until api is called,
                                    // it shows no items found layout.
                                    this.state.componentDidMountFlag &&
                                    <div className="body-wrapper">
                                        <div className="search-addnew-bg">
                                            <div className="search-addnew">
                                                <div className="search-filter-layout">
                                                    <FilterDropDown
                                                        placeholder={this.state.resultSizePlaceholder}
                                                        dropdownArr={this.state.resultSizeArr}
                                                        onDropDownItemClick={this.resultSizeDropdownClick}
                                                        themeSettings={themeSettings}
                                                        mleft={0}
                                                    />
                                                    <div className="search-col m-l-10">
                                                        <input 
                                                            name="clientSearchkey" 
                                                            type="text"
                                                            onChange={this.handleChange}
                                                            placeholder="Search" 
                                                            onKeyPress={this.onEnterBtnPress}
                                                            value={this.state.clientSearchkey} />
                                                        <SearchSpan 
                                                            className="material-icons"
                                                            themeSettings={themeSettings}
                                                            onClick = {this.onSearchIconClick}>search</SearchSpan>
                                                    </div>
                                                    {this.state.filterDeptArr.length > 0 && (
														<FilterDropDown
															placeholder={this.state.selectedFilterDepartmentName}
															dropdownArr={this.state.filterDeptArr}
															onDropDownItemClick={this.deptFilterDropdownClick}
															name={"name"}
															themeSettings={themeSettings}
															dropdownWidth={"120px"}
														/>
													)}
                                                </div>
                                                <AddNewButtonLayout
                                                    themeSettings={themeSettings}
                                                >
                                                    <a onClick={this.addDashboard} href="javascript:void(0)" data-toggle="modal" data-target="#addnewModal">
                                                        <span className="material-icons">add_circle</span>
                                                        <p>Add Dashboard</p>
                                                    </a>
                                                </AddNewButtonLayout>
                                            </div>
                                        </div>
                                        {
                                            !isEmptyArray(this.state.datalist) && 
                                            <div className="common-tab-bg">
                                                <div className="common-table" style={{width:"100%"}}>
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center" width={"5%"}>No</th>
                                                            <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortDashboardName)}>
                                                                <div className="sort-header">Name
                                                                    <span className={(this.state.sort === sortDashboardName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div className="sort-header">Client's Name</div>
                                                            </th>
                                                            <th>
                                                                <div className="sort-header">Client's Description</div>
                                                            </th>
                                                            <th>
                                                                <div className="sort-header">Department</div>
                                                            </th>
                                                            <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortRootExecuteTemplateId)}>
                                                                <div className="sort-header">Execute Id
                                                                    <span className={(this.state.sort === sortRootExecuteTemplateId)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th>
                                                            <th className="c-pointer">
                                                                <div className="sort-header">Execute Name
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            !isEmptyArray(this.state.datalist) && 
                                                            this.state.datalist.map((item,idx) => {
                                                                let departmentList = isJsonString(item.departmentList) ? JSON.parse(item.departmentList) : item.departmentList;
                                                                return <tr>
                                                                    <td className="text-center">{((this.state.currentPageNo - 1) * this.state.resultSize) + (++idx)}</td>
                                                                    <td className={'framework-group-line'} style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                                                        {item.dashboardName}
                                                                        <div className="tool hover-item framework-info-icon ml-1" data-title={item.dashboardDescription}>
                                                                            <span
                                                                                className="material-icons-outlined framework-icon"
                                                                                style={{ cursor: 'pointer', verticalAlign: 'middle' }}
                                                                            >
                                                                                info
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    <td>{item.dashboardClientName}</td>
                                                                    <td>{item.dashboardClientDescription}</td>
                                                                    <td>{departmentList[0].departmentShortName}</td>
                                                                    <td>{!isEmptyVariable(item.rootExecuteTemplateId)?item.rootExecuteTemplateId:"-"}</td>
                                                                    <td>{!isEmptyVariable(item.rootExecuteTemplateName)?item.rootExecuteTemplateName:"-"}</td>
                                                                </tr>
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            
                                                </div>
                                            </div>
                                        }
                                        {
                                            this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) &&
                                            <div class="no-items-layout">
                                                <div class="no-items-card">
                                                    <h6>
                                                    {
                                                        isEmptyVariable(this.state.apiSearchKey)?
                                                        Constants.NO_RECORDS_WARNING
                                                        :
                                                        Constants.EMPTY_SEARCH_WARNING
                                                    }
                                                    </h6>
                                                </div>
                                            </div>
                                        }
                                        <div className="pagination-layout">
                                            <div className="row custom-row">
                                                <div className="col-md-9 custom-col">
                                                {
                                                    (this.state.totalCount > this.state.datalist.length) && 
                                                    <Pagination 
                                                        totalLength ={this.state.totalCount} 
                                                        items={this.state.datalist} 
                                                        onChangePage={this.onChangePage} 
                                                        pageSize={this.state.resultSize}
                                                        currentPageNo = {this.state.currentPageNo}
                                                        initialPage={this.state.currentPageNo} 
                                                        themeSettings={themeSettings}/>
                                                }
                                                </div>
                                                <div className="col-md-3 custom-col">
                                                    <p>{"Total Records: "+this.state.totalCount}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type={Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                            themeSettings={themeSettings}
                        />
                        <SelectDepartmentDialog
                            showDeptDialog={this.state.showSelectDeptDialog}
                            handleSelectDeptDialogClose={this.handleSelectDeptDialogClose}
                            handleSelectDeptDialogSaveClose={this.handleSelectDeptDialogSaveClose}
                            selectedDeptId={this.state.selectedDepartmentId}
                            departmentArr={this.state.departmentList}
                            themeSettings = {themeSettings}
                        />
                    </section>
                </main>
            </Router>
        );
    }
}

export default clientDashboard;